import { motion } from "framer-motion";
import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { fetchProjects } from "../../utils/requests";
import { ProjectPopup } from "./project-popup/project-popup";
import { useSectionVisibility } from "../../utils/ScrollContext";
import { Config } from "../../config/config";
import { Carousel } from "react-responsive-carousel";
import { useLocation } from 'react-router-dom'

import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./project-gallery.css";
import { FaPlus } from "react-icons/fa";
import {
  ANIMATION_TIMING,
  EASING_CURVES,
} from "../../utils/motion";

const ProjectGallery = ({ minimified = false }) => {
  // if (!minimified) {
  // const { ref: sectionRef } = useSectionVisibility("project-gallery", 0.3);
  // } else {
    const sectionRef = useRef(null);
  // }
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  let location = useLocation();


  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      if (hash.includes("#projets")) {
        const element = document.getElementById(hash.split("#")[1]);
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  const loadProjects = () => {
    fetchProjects().then((data) => {
      const projects = data.data.map((project) => ({
        id: project.id,
        date: project.attributes.date,
        title: project.attributes.title,
        description: project.attributes.description,
        thumbnail: project.attributes.thumbnail.data.attributes.url,
        brand: project.attributes.brand.data.attributes.url,
        youtube_urls: project.attributes.youtube_urls
          ?.split("\n")
          .map((video) => ({
            url: video,
          })),
      }));
      projects.sort((a, b) => new Date(b.date) - new Date(a.date));
      setProjects(projects);
    });
  };

  useEffect(() => {
    loadProjects();
  }, []);

  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = (project) => {
    setSelectedProject(project);
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <div ref={sectionRef} id="projets" className="bg-projects z-10" aria-label="Cases studies de Studio-Sam">
      <div className="framer-section">
        <motion.h1
          className="projects-title text-7xl"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: ANIMATION_TIMING.durations.normal,
            ease: EASING_CURVES.smooth,
          }}
        >
          case studies
        </motion.h1>

        <motion.div
          className="project-carousel-container flex-col items-center z-20"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            duration: ANIMATION_TIMING.durations.normal,
            delay: 0.2,
            ease: EASING_CURVES.smooth,
          }}
        >
          <Carousel
            showThumbs={false}
            showStatus={false}
            showIndicators={false}
            // infiniteLoop={true}
            // autoPlay={false}
            // interval={5000}
            centerMode={true}
            centerSlidePercentage={window.innerWidth < 768 ? 60 : 30}
            className="project-carousel"
            swipeable={false}
            emulateTouch={false}
            dynamicHeight={true}
            transitionTime={250}
            onClickItem={(index, item) => handleOpen(projects[index])}
          >
            {projects.map((project, index) => (
              <motion.div
                key={project.id}
                className="project-card-carousel"
                // onClick={() => handleOpen(project)}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.1,
                  delay: 0,
                  ease: EASING_CURVES.smooth,
                }}
                whileHover={{ y: -10 }}
                whileTap={{ scale: 0.98 }}
              >
                <div className="project-card-image-container">
                  <img
                    src={Config.api.mediaUrl + project.thumbnail}
                    alt={project.title}
                    className="project-card-image"
                  />
                  {/* <div className="project-card-overlay"></div> */}
                </div>
                <div className="project-card-content">
                  <h3 className="project-card-title">{project.title}</h3>
                  {project.description && (
                    <p className="project-card-description">
                      {project.type || "Motion design"}
                    </p>
                  )}
                </div>
              </motion.div>
            ))}
          </Carousel>

          {!minimified && (
            <Link to="/gallery">
              <motion.button
                className="flex color-primary items-center p-2 bg-black text-primary font-lexend shadow-lg mb-[20vh] font-bold z-10 "
                style={{
                  scale: 2,
                  zIndex: 1,
                }}
                whileHover={{ scale: 2.05 }}
                whileTap={{ scale: 1.95 }}
                transition={{
                  duration: ANIMATION_TIMING.durations.normal,
                  ease: EASING_CURVES.smooth,
                }}
              >
                {" "}
                Découvrir plus de projets
              </motion.button>
            </Link>
          )}
        </motion.div>

        <ProjectPopup
          isOpen={isOpen}
          onClose={handleClose}
          project={selectedProject}
        />
      </div>
    </div>
  );
};

export default ProjectGallery;
